import API from "./api";

// CREATE FIRM
export const createFirm = async (data) => {
  const res = await API.post("/firms", data);
  return res.data.firm;
};

// GET FIRMS
export const getFirms = async () => {
  const res = await API.get("/firms");
  return res.data.firms;
};

// UPDATE FIRM
export const updateFirm = async (id, data) => {
  const res = await API.put(`/firms/${id}`, data);
  return res.data.firm;
};